<template>
  <div class="px-3 py-1 text-sm border-t flex">
    <div>Tinkerwell: {{ loadTime ? `Loaded in ${loadTime}s` : 'Loading'}}</div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      mountedAt: Date.now(),
      loadTime: null,
    };
  },
  created() {
    this.$root.$on('php.loaded', () => {
      this.loadTime = ((Date.now() - this.mountedAt) / 1000).toFixed(1);
    });
  },
};
</script>

<style scoped>

</style>
